// src/components/ProfileIncompletePrompt.tsx
// Unified profile completion prompt used across Discover, Chats, and Sessions tabs

import React from 'react';
import { IonButton, IonIcon, IonText } from '@ionic/react';
import { pencilOutline, personOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { Profile } from '../types/profile';
import { getProfileIncompleteMessage } from '../utils/profileUtils';
import './ProfileIncompletePrompt.css';

interface ProfileIncompletePromptProps {
  profile: Profile | null;
  /**
   * Optional custom action description (e.g., "discovering gaming partners", "chatting", "hosting sessions")
   * Defaults to generic "using Meeplr"
   */
  actionContext?: string;
}

export const ProfileIncompletePrompt: React.FC<ProfileIncompletePromptProps> = ({
  profile,
  actionContext = 'using Dice Cat'
}) => {
  const history = useHistory();

  return (
    <div className="profile-incomplete-prompt">
      <IonIcon icon={personOutline} className="prompt-icon" color="primary" />
      <IonText>
        <h2 className="prompt-title">Welcome to Dice Cat! 🎲</h2>
        <p className="prompt-message">
          {getProfileIncompleteMessage(profile)}
        </p>
        <p className="prompt-action-message">
          Complete your profile to start {actionContext}!
        </p>
      </IonText>
      <IonButton
        onClick={() => history.push('/profile/edit')}
        size="large"
        className="complete-profile-button"
      >
        <IonIcon slot="start" icon={pencilOutline} />
        Complete Profile
      </IonButton>
    </div>
  );
};